<template>
    <div class="d-flex align-items-center switch">
        <span
            v-if="label"
            class="switch-label"
        >
            {{ label }}
        </span>
        <button
            @click="inputValue = !inputValue"
            class="switch-button"
            :class="{ 'active': inputValue }"
            :aria-label="inputValue ? $t('general.on') : $t('general.off')"
        ></button>
    </div>
</template>

<script>
    export default {
        name: 'UiSwitch',
        data() {
            return {
                inputValue: this.value,
            };
        },
        props: {
            label: {
                type: String,
                default: null,
            },
            value: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
            inputValue() {
                this.$emit('input', this.inputValue);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .switch {
        &-button {
            position: relative;
            width: 44px;
            height: 30px;
            margin-left: auto;
            background: rgba($primary, 0.3);
            border-radius: 15px;
            box-shadow: inset 0 0 2px rgba($primary, 0.2);
            transition: background-color 0.3s;

            &::before {
                position: absolute;
                top: 2px;
                left: 2px;
                width: 26px;
                height: 26px;
                content: '';
                background: #fff;
                border-radius: 50%;
                box-shadow: 1px 1px 2px rgba($primary, 0.05);
                transition: left 0.3s 0.1s;
            }

            &.active {
                background: $primary;

                &::before {
                    left: 16px;
                }
            }
        }
    }
</style>
